

angular
.module('inkfinder')
.filter('positionFilter', function(_) {
  return function(input, area_id) {
    let output = [];

    _.each(input, function(location) {
      if (location.area.id === area_id) {
        output.push(location);
      }
    });
    return output;
  };
})

.filter('hour_range', function() {
  return function(input, min, max) {
    min = parseInt(min, 10); // Make string input int
    max = parseInt(max, 10);
    for (let i = min; i <= max; i++) {
      input.push(i);
    }
    return input;
  };
})

.filter('minute_range', function() {
  return function(input, min, max) {
    min = parseInt(min, 10); // Make string input int
    max = parseInt(max, 10);
    for (let i = min; i <= max; i += 15) {
      input.push(i);
    }
    return input;
  };
})

.filter('reverse', function() {
  return function(items) {
    return items.slice().reverse();
  };
})

.filter('bigmoney', function(_) {
  return function(input, currency, decimals) {
    if (_.isUndefined(input)) {
      return '';
    }
    let val = (input ? input : 0);
    let thousands = 0;
    if (val < 1000) {
      val = Math.round(val);
    }
    while (val >= 1000 && thousands < 2) {
      val /= 1000;
      thousands++;
    }
    if (thousands) {
      if (decimals === null) {
        decimals = 1;
      }
      let factor_of_ten = Math.pow(10, decimals);
      val = Math.round(val * factor_of_ten) / factor_of_ten;
    }
    if (thousands === 1) {
      val += 'k';
    } else if (thousands === 2) {
      val += 'm';
    }
    if (currency) {
      return currency + val;
    }
    return '$' + val;
  };
})

.filter('tel', function() {
  return function(tel) {
    if (!tel) {
      return '';
    }
    let value = tel.toString().trim().replace(/^\+/, '');
    if (value.match(/[^0-9]/)) {
      return tel;
    }
    let country;
    let city;
    let number;
    switch (value.length) {
      case 10: // +1PPP####### -> C (PPP) ###-####
        country = 1;
        city = value.slice(0, 3);
        number = value.slice(3);
        break;
      case 11: // +CPPP####### -> CCC (PP) ###-####
        country = value[0];
        city = value.slice(1, 4);
        number = value.slice(4);
        break;
      case 12: // +CCCPP####### -> CCC (PP) ###-####
        country = value.slice(0, 3);
        city = value.slice(3, 5);
        number = value.slice(5);
        break;
      default:
        return tel;
    }
    if (country === 1) {
      country = '';
    }
    number = number.slice(0, 3) + '-' + number.slice(3);
    return (country + ' (' + city + ') ' + number).trim();
  };
})

.filter('noFractionCurrency', function($filter, $locale) {
  let currencyFilter = $filter('currency');
  let formats = $locale.NUMBER_FORMATS;
  return function(amount, currencySymbol) {
    amount = amount ? Number(amount).toFixed(2) : 0.00;
    let value = currencyFilter(amount, currencySymbol);
    // split into parts
    let parts = value.split(formats.DECIMAL_SEP);
    let dollar = parts[0];
    let cents = parts[1] || '00';
    cents = cents.substring(0, 2).toString() === '00' ?
    cents.substring(2) : '.' + cents; // remove '00' cent amount
    return dollar + cents;
  };
})

.filter('percent', function($filter, _) {
  return function(input, decimals) {
    if (_.isUndefined(input)) {
      return '';
    }
    return $filter('number')(input * 100, decimals) + '%';
  };
})

.filter('cut', function() {
  return function(value, wordwise, max, tail) {
    if (!value) return '';

    max = parseInt(max, 10);
    if (!max) return value;
    if (value.length <= max) return value;

    value = value.substr(0, max);
    if (wordwise) {
      let lastspace = value.lastIndexOf(' ');
      if (lastspace !== -1) {
        // Also remove . and , so its gives a cleaner result.
        if (value.charAt(lastspace - 1) === '.' ||
        value.charAt(lastspace - 1) === ',') {
          lastspace -= 1;
        }
        value = value.substr(0, lastspace);
      }
    }
    return value + (tail || ' …');
  };
})

.filter('activityFilter', function(_) {
  return function(items, hasMessages, hasAppointmentActivity,
  hasProjectActivity) {
    let filtered = [];
    _.each(items, function(item) {
      if (!_.isUndefined(item)) {
        if (hasMessages && _.isUndefined(item.type)) {
          filtered.push(item);
        }
        if (hasAppointmentActivity && item.object === 'appointment') {
          filtered.push(item);
        }
        if (hasProjectActivity && item.object === 'project') {
          filtered.push(item);
        }
      }
    });
    return filtered;
  };
});



// WEBPACK FOOTER //
// ./filters/filters.js